<template>
  <h5 v-show="showTitle">Invoices</h5>
  <span>{{ title }}</span>
  <div class="row">
    <!-- Search -->
    <div class="col-2">
      <z-search v-model.trim="searchTerm" class="mt-2" name="search" label="" placeholder="Search" :readonly="isLoading" />
    </div>
    <!-- Placeholder -->
    <div class="col-1">
      <div class="row mt-2">
        <div>
          <button v-if="!isCancelled" class="btn btn-primary btn-sm" :disabled="isLoading" @click="addInvoice">Add Invoice</button>
        </div>
        <!-- <div v-show="isChecked" class="ml-2">
          <button class="btn btn-primary btn-sm" :disabled="isLoading" @click="deleteInvoices">Delete</button>
        </div> -->
      </div>
    </div>
    <!-- Filter -->
    <div v-if="isAdmin" class="col-3">
      <Multiselect
        ref="searchLocation"
        v-model="foundLocation"
        class="form-control custom-multiselect"
        placeholder="type to search for a location"
        :close-on-select="true"
        :filter-results="false"
        :min-chars="1"
        :resolve-on-load="false"
        :delay="500"
        :searchable="true"
        :open-direction="'bottom'"
        :options="
          async (query) => {
            return await fetchLocations(query)
          }
        "
        label="name"
        value-prop="id"
        @select="selectedLocation"
        @clear="clearSelection"
      />
    </div>
    <div v-else class="col-3"></div>
    <div class="col">
      <div class="row">
        <!-- Pagination -->
        <div class="col-2">
          <z-select v-model="pageSize" :options="pageSizes" label="" name="pageSize" :disabled="isLoading" />
        </div>
        <div class="col-3"></div>
        <div class="col-5">
          <nav>
            <z-paginate v-model="page" :page-count="pages" />
          </nav>
        </div>
        <div class="col-2 text-right">
          <h5 class="mt-0 me-0" title="# items">{{ numItems }}</h5>
          <span class="custom-items">items</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { authStore } from '@/stores/auth'
import { invoiceStore } from '@/stores/invoice'
import { locationStore } from '@/stores/location'
import ZSearch from '@/components/utilities/elements/Search.vue'
import ZSelect from '@/components/utilities/elements/Select.vue'
import ZPaginate from '@/components/utilities/elements/Paginate.vue'
import Multiselect from '@vueform/multiselect'
export default {
  name: 'InvoiceHeader',
  components: {
    ZSearch,
    ZSelect,
    ZPaginate,
    Multiselect
  },
  props: {
    pages: Number,
    pageSizes: Array,
    numItems: Number,
    showTitle: {
      type: Boolean,
      default: true
    },
    firm: Number
  },
  data() {
    return {
      title: '',
      foundLocation: null
    }
  },
  emits: ['search', 'add', 'delete'],
  computed: {
    ...mapState(authStore, ['profile', 'isCancelled']),
    ...mapState(invoiceStore, ['loading', 'listParams', 'isChecked']),
    ...mapState(locationStore, ['foundLocations']),
    isLoading() {
      return this.loading.invoices
    },
    isAdmin() {
      let _is = false
      if ([1].includes(this.profile.roles[0])) {
        _is = true
      }
      return _is
    },
    page: {
      get() {
        return this.listParams.page
      },
      set(value) {
        this.setListParam({
          name: 'page',
          value: parseInt(value)
        })
        this.search('')
      }
    },
    pageSize: {
      get() {
        return this.listParams.pageSize
      },
      set(value) {
        this.setListParam({
          name: 'pageSize',
          value: parseInt(value)
        })
        this.page = 1
      }
    },
    filterBy: {
      get() {
        return this.listParams.filterBy
      },
      set(value) {
        this.setListParam({
          name: 'filterBy',
          value: value
        })
        this.page = 1
      }
    },
    searchTerm: {
      get() {
        return this.listParams.searchTerm
      },
      set(value) {
        this.setListParam({
          name: 'searchTerm',
          value: value
        })
        this.page = 1
      }
    }
  },
  methods: {
    ...mapActions(invoiceStore, ['setListParam']),
    ...mapActions(locationStore, ['searchLocations']),
    setFilter() {
      this.foundLocation = this.listParams.filter ? this.listParams.filter : null
      this.selectedLocation()
    },
    change() {
      this.search(this.listParams.searchTerm)
    },
    search() {
      this.$emit('search', this.page, this.listParams.searchTerm)
    },
    async fetchLocations(query) {
      let search = {
        search: query,
        type: 99,
        firm: this.profile.firm
      }
      let results = await this.searchLocations(search)
      return results
    },
    addInvoice() {
      this.$emit('add')
    },
    deleteInvoices() {
      this.$emit('delete')
    },
    clearSelection() {
      this.setListParam({
        name: 'filterBy',
        value: null
      })
      this.page = 1
      this.$emit('search', 1)
    },
    selectedLocation() {
      console.log('Selected Location', this.foundLocation)
      this.$nextTick(() => {
        let found = this.foundLocations.find((x) => parseInt(x.id) === parseInt(this.foundLocation))
        if (found) {
          this.setListParam({
            name: 'filterBy',
            value: found.id
          })
          this.page = 1
          // this.$emit('search', 1)
        }
      })
    }
  }
}
</script>
<style lang="scss">
.filterIcon {
  top: 8px;
  font-size: 1.2em;
}
.filterListing {
  float: left;
}
.custom-items {
  right: 10px;
  top: -10px;
  position: relative;
}
</style>
